import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/lib/motion";

const projects = [
  {
    id: "P01",
    title: "Aurora Tech Summit",
    cat: "Custom Exhibit · 40×50",
    year: "2025",
    img: "https://images.unsplash.com/photo-1761225646548-bc92fea0dc72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmFsJTIwZXhoaWJpdGlvbiUyMGJvb3RofGVufDB8fHx8MTc4NDkxNDQ5OXww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "P02",
    title: "Porsche Brand Activation",
    cat: "Brand Activation · Experiential",
    year: "2025",
    img: "https://images.unsplash.com/photo-1778507936181-c8022255f42b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxicmFuZCUyMGFjdGl2YXRpb24lMjBleHBlcmllbnRpYWwlMjBtYXJrZXRpbmclMjBldmVudCUyMGJvb3RoJTIwY3Jvd2R8ZW58MHx8fHwxNzg0OTgzNjA5fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "P03",
    title: "LED Walls & Stage Build",
    cat: "Fabrication · AV Integration",
    year: "2024",
    img: "https://images.pexels.com/photos/11410604/pexels-photo-11410604.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "P04",
    title: "Modular Trade Show Booth",
    cat: "Custom Exhibit · 30×30",
    year: "2024",
    img: "https://images.unsplash.com/photo-1561019562-1b2f1e0f895f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjB0cmFkZSUyMHNob3clMjBleGhpYml0aW9uJTIwYm9vdGglMjBzdGFuZHxlbnwwfHx8fDE3ODQ5ODM2ODd8MA&ixlib=rb-4.1.0&q=85",
  },
];

export default function Portfolio() {
  const [hover, setHover] = useState(null);

  return (
    <section id="work" className="mx-auto max-w-[1600px] px-6 py-28 md:px-10 md:py-40">
      <div className="mb-16 flex items-end justify-between">
        <div>
          <div className="mb-5 flex items-center gap-3">
            <span className="h-px w-12 bg-[#FF3B30]" />
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-white/50">
              Selected work
            </span>
          </div>
          <Reveal>
            <h2 className="font-display text-4xl font-bold uppercase leading-[0.95] tracking-tighter md:text-6xl lg:text-7xl">
              Built to be<br />remembered.
            </h2>
          </Reveal>
        </div>
        <span className="hidden font-mono text-xs uppercase tracking-[0.2em] text-white/40 md:block">
          ({projects.length}) Case Studies
        </span>
      </div>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
        {projects.map((p, i) => (
          <Reveal
            key={p.id}
            delay={(i % 2) * 0.1}
            className={i % 2 === 1 ? "md:mt-20" : ""}
          >
            <a
              href="#quote"
              data-testid={`portfolio-item-${p.id}`}
              onMouseEnter={() => setHover(p.id)}
              onMouseLeave={() => setHover(null)}
              onClick={(e) => {
                e.preventDefault();
                document.querySelector("#quote")?.scrollIntoView({ behavior: "smooth" });
              }}
              className="group block"
            >
              <div className="relative aspect-[4/5] overflow-hidden rounded-2xl border border-white/10">
                <motion.img
                  src={p.img}
                  alt={p.title}
                  animate={{
                    opacity: hover && hover !== p.id ? 0.3 : 1,
                    scale: hover === p.id ? 1.05 : 1,
                  }}
                  transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                  className="h-full w-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
                <span className="absolute left-6 top-6 font-mono text-xs tracking-[0.2em] text-white/70">
                  {p.id}
                </span>
                <div className="absolute right-6 top-6 flex h-11 w-11 items-center justify-center rounded-full bg-white/0 opacity-0 backdrop-blur transition-all duration-500 group-hover:bg-white group-hover:opacity-100">
                  <ArrowUpRight className="h-5 w-5 text-black" />
                </div>
              </div>
              <div className="mt-5 flex items-baseline justify-between">
                <div>
                  <h3 className="font-display text-2xl font-medium tracking-tight md:text-3xl">
                    {p.title}
                  </h3>
                  <p className="mt-1 font-mono text-xs uppercase tracking-[0.15em] text-white/45">
                    {p.cat}
                  </p>
                </div>
                <span className="font-mono text-sm text-white/40">{p.year}</span>
              </div>
            </a>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
